// Initials avatar — pure presentational. Clerk owns the real profile
// image in <UserProfile>; this is the lightweight chip used elsewhere.

import React from "react";
import { initialsOf } from "../lib/format";

export function Avatar({
  email = "",
  name = "",
  size = "md",
  status = false,
  onClick,
  style,
}: {
  email?: string;
  name?: string;
  size?: "sm" | "md" | "lg";
  status?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
}) {
  const cls = `avatar ${size === "lg" ? "lg" : size === "sm" ? "sm" : ""}`;
  return (
    <button
      className={cls}
      onClick={onClick}
      style={style}
      type="button"
      aria-label={name || email || "user"}
    >
      <span>{initialsOf(name, email)}</span>
      {status && <span className="avatar-status" />}
    </button>
  );
}
